function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import "./endorsement.scss";
import { formatRut } from "../../../helperComponents/InputRut/rutValidate";
import { FaEye, FaEdit, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import * as moment from "moment";
import { getSeparatorByCurrency } from "../../../utils/currency";

var ListEndorsement = function ListEndorsement(props) {
  var endorsements = props.endorsements,
      endorsement_types = props.endorsement_types,
      sortField = props.sortField,
      sortOrder = props.sortOrder,
      onSort = props.onSort; // Hook para detectar el tamaño de la pantalla

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isSmallScreen = _React$useState2[0],
      setIsSmallScreen = _React$useState2[1];

  React.useEffect(function () {
    var checkScreenSize = function checkScreenSize() {
      setIsSmallScreen(window.innerWidth <= 800);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return function () {
      return window.removeEventListener('resize', checkScreenSize);
    };
  }, []); // Mapeo de columnas a campos de Elasticsearch

  var columnFieldMap = {
    "Nº Sol. Endoso": "id",
    "Nº Póliza": "poliza.code.keyword",
    "Asegurado": "poliza.asegurado.full_name.keyword",
    "Estado Endoso": "status_name.keyword",
    "Tipo Endoso": "endorsement_type.keyword",
    "Compañía": "poliza.company.name.keyword",
    "Ramo": "poliza.ramo.keyword",
    "Razón Cancelación": "cancel_reason_name.keyword",
    "Prima Total Endoso": "total_bonus",
    "Creado por": "created_by_email.keyword",
    "Fecha Creación": "created_at",
    "Fecha Inicio Vigencia": "start_date",
    "Acciones": "" // No ordenable

  };

  var getSortIcon = function getSortIcon(columnName) {
    var field = columnFieldMap[columnName];

    if (!field || !sortField || sortField !== field) {
      return /*#__PURE__*/React.createElement(FaSort, {
        style: {
          marginLeft: "4px",
          opacity: 0.4,
          fontSize: "12px"
        }
      });
    }

    return sortOrder === "asc" ? /*#__PURE__*/React.createElement(FaSortUp, {
      style: {
        marginLeft: "4px",
        color: "#2596be",
        fontSize: "14px"
      }
    }) : /*#__PURE__*/React.createElement(FaSortDown, {
      style: {
        marginLeft: "4px",
        color: "#2596be",
        fontSize: "14px"
      }
    });
  };

  var handleHeaderClick = function handleHeaderClick(columnName, event) {
    event.preventDefault();
    event.stopPropagation();
    var field = columnFieldMap[columnName];

    if (field && onSort) {
      onSort(field);
    }
  }; // Función helper para estilos de celdas que permiten múltiples líneas


  var getCellStyle = function getCellStyle(width) {
    var additionalStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _objectSpread({
      width: isSmallScreen ? "auto" : width,
      padding: isSmallScreen ? "8px 4px" : "4px 8px",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "normal",
      fontSize: "12px"
    }, additionalStyles);
  }; // Función helper para estilos de encabezados


  var getHeaderStyle = function getHeaderStyle(width) {
    return {
      width: isSmallScreen ? "auto" : width,
      cursor: "pointer",
      userSelect: "none",
      whiteSpace: "normal",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      padding: isSmallScreen ? "8px 4px" : undefined
    };
  }; // Estado para el tooltip de scroll


  var _React$useState3 = React.useState({
    show: false,
    text: "",
    x: 0,
    y: 0
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      scrollTooltip = _React$useState4[0],
      setScrollTooltip = _React$useState4[1]; // Ref para la tabla y el contenedor scrollable


  var tableRef = React.useRef(null);
  var scrollRef = React.useRef(null); // Nombres de las columnas para el tooltip

  var columnNames = ["Nº Sol. Endoso", "Nº Póliza", "Asegurado", "Estado Endoso", "Tipo Endoso", "Compañía", "Ramo", "Razón Cancelación", "Prima Total Endoso", "Creado por", "Fecha Creación", "Fecha Inicio Vigencia", "Acciones"]; // Función para manejar el scroll y mostrar tooltip

  var handleScroll = function handleScroll(event) {
    if (!tableRef.current || !scrollRef.current) return;
    var ths = tableRef.current.querySelectorAll('thead th');
    if (!ths.length) return;
    var scrollLeft = scrollRef.current.scrollLeft;
    var clientWidth = scrollRef.current.clientWidth; // Encontrar la columna que está en el centro del viewport

    var viewportCenter = scrollLeft + clientWidth / 2;
    var closestColumn = 0;
    var minDistance = Infinity;
    ths.forEach(function (th, idx) {
      var thElement = th;
      var thLeft = thElement.offsetLeft;
      var thWidth = thElement.offsetWidth;
      var thCenter = thLeft + thWidth / 2;
      var distance = Math.abs(thCenter - viewportCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestColumn = idx;
      }
    }); // Posicionar el tooltip justo encima de la barra de scroll

    var scrollRect = scrollRef.current.getBoundingClientRect();
    var scrollbarY = scrollRect.bottom - 20; // 20px arriba de la barra
    // Calcular posición X basada en la columna más cercana al centro

    var thElement = ths[closestColumn];
    var thLeft = thElement.offsetLeft;
    var thWidth = thElement.offsetWidth;
    var thCenter = thLeft + thWidth / 2; // Ajustar la posición X para que esté centrada en la columna

    var adjustedX = scrollRect.left + (thCenter - scrollLeft); // Solo mostrar tooltip si hay scroll horizontal

    if (scrollLeft > 0 || scrollRef.current.scrollWidth > scrollRef.current.clientWidth) {
      setScrollTooltip({
        show: true,
        text: "Columna: ".concat(columnNames[closestColumn]),
        x: adjustedX,
        y: scrollbarY
      });
    }
  }; // Función para ocultar tooltip cuando se suelta el scroll


  var handleScrollEnd = function handleScrollEnd() {
    setScrollTooltip(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        show: false
      });
    });
  }; // Función para manejar cuando se suelta el mouse o el touch


  var handleMouseUp = function handleMouseUp() {
    handleScrollEnd();
  };

  var handleTouchEnd = function handleTouchEnd() {
    handleScrollEnd();
  }; // Función para manejar cuando se mueve el mouse sobre la barra de scroll


  var handleMouseMove = function handleMouseMove(event) {
    if (!scrollRef.current) return;
    var rect = scrollRef.current.getBoundingClientRect();
    var mouseY = event.clientY; // Solo mostrar tooltip si el mouse está cerca de la barra de scroll

    if (mouseY >= rect.bottom - 30) {
      handleScroll(event);
    } else {
      handleScrollEnd();
    }
  };

  var renderStatusLabel = function renderStatusLabel(endorsement) {
    switch (endorsement.status_name) {
      case "Pendiente":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-default"
        }, endorsement.status_name);

      case "Aprobado":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-success"
        }, endorsement.status_name);

      case "Rechazado":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-danger"
        }, endorsement.status_name);
    }
  };

  var getEndorsementTypeLabel = function getEndorsementTypeLabel(endorsement_type) {
    if (!endorsement_types || !Array.isArray(endorsement_types)) return endorsement_type || "-";
    var type = endorsement_types.find(function (type) {
      return type.value === endorsement_type;
    });
    return type ? type.label : endorsement_type || "-";
  };

  var formatCurrency = function formatCurrency(amount) {
    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CLP';
    if (!amount || amount === 0) return "-";

    try {
      // Usar las funciones existentes del proyecto para mantener consistencia
      var currencyFormat = getSeparatorByCurrency(currency); // Formatear el número con los separadores correctos

      var formattedNumber = new Intl.NumberFormat('es-CL', {
        minimumFractionDigits: currencyFormat.decimalScale,
        maximumFractionDigits: currencyFormat.decimalScale,
        useGrouping: true
      }).format(amount); // Aplicar el prefijo según el tipo de moneda

      return "".concat(currencyFormat.prefix || '').concat(formattedNumber);
    } catch (error) {
      // Fallback: mostrar solo el número con el código de moneda
      return "".concat(currency, " ").concat(new Intl.NumberFormat('es-CL').format(amount));
    }
  };

  if (endorsements && endorsements.length > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "table-responsive",
      style: {
        overflowX: "auto",
        overflowY: "visible",
        width: "100%",
        position: "relative",
        WebkitOverflowScrolling: "touch"
      },
      ref: scrollRef,
      onScroll: handleScroll,
      onMouseUp: handleMouseUp,
      onTouchEnd: handleTouchEnd,
      onMouseMove: handleMouseMove
    }, /*#__PURE__*/React.createElement("table", {
      ref: tableRef,
      className: "table table-striped table-sm table-bordered cntListEndorsement",
      "data-toggle": "table",
      style: {
        width: "100%",
        minWidth: isSmallScreen ? "100%" : "1400px",
        tableLayout: isSmallScreen ? "auto" : "fixed"
      }
    }, /*#__PURE__*/React.createElement("thead", {
      className: "tableHeader"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Nº Sol. Endoso", e);
      },
      style: getHeaderStyle("6%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "N\xBA Sol. Endoso", getSortIcon("Nº Sol. Endoso"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Nº Póliza", e);
      },
      style: getHeaderStyle("10%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "N\xBA P\xF3liza", getSortIcon("Nº Póliza"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Asegurado", e);
      },
      style: getHeaderStyle("12%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Asegurado", getSortIcon("Asegurado"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Estado Endoso", e);
      },
      style: getHeaderStyle("8%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Estado Endoso", getSortIcon("Estado Endoso"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Tipo Endoso", e);
      },
      style: getHeaderStyle("8%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Tipo Endoso", getSortIcon("Tipo Endoso"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Compañía", e);
      },
      style: getHeaderStyle("12%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Compa\xF1\xEDa", getSortIcon("Compañía"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Ramo", e);
      },
      style: getHeaderStyle("8%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Ramo", getSortIcon("Ramo"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Razón Cancelación", e);
      },
      style: getHeaderStyle("8%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Raz\xF3n Cancelaci\xF3n", getSortIcon("Razón Cancelación"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Prima Total Endoso", e);
      },
      style: getHeaderStyle("6%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Prima Total Endoso", getSortIcon("Prima Total Endoso"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Creado por", e);
      },
      style: getHeaderStyle("12%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Creado por", getSortIcon("Creado por"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Fecha Creación", e);
      },
      style: getHeaderStyle("6%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Fecha Creaci\xF3n", getSortIcon("Fecha Creación"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      onClick: function onClick(e) {
        return handleHeaderClick("Fecha Inicio Vigencia", e);
      },
      style: getHeaderStyle("6%"),
      title: "Click para ordenar"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        flexWrap: isSmallScreen ? "wrap" : "nowrap"
      }
    }, "Fecha Inicio Vigencia", getSortIcon("Fecha Inicio Vigencia"))), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      style: getHeaderStyle("7%")
    }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", {
      className: "tableBody"
    }, endorsements && endorsements.map(function (endorsement) {
      var _endorsement$poliza, _endorsement$poliza2, _endorsement$poliza3, _endorsement$poliza4, _endorsement$poliza4$, _endorsement$poliza5;

      return /*#__PURE__*/React.createElement("tr", {
        key: "endorsement_".concat(endorsement.id)
      }, /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("6%")
      }, endorsement.id ? endorsement.id : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("10%", {
          textAlign: "center"
        })
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(endorsement.poliza.id),
        style: {
          fontSize: "13px",
          fontWeight: "600",
          color: "#2596be",
          textDecoration: "none",
          letterSpacing: "0.5px"
        },
        title: "Ver detalles de la p\xF3liza"
      }, endorsement !== null && endorsement !== void 0 && endorsement.poliza.code ? endorsement === null || endorsement === void 0 ? void 0 : endorsement.poliza.code : "-")), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("12%")
      }, endorsement !== null && endorsement !== void 0 && (_endorsement$poliza = endorsement.poliza) !== null && _endorsement$poliza !== void 0 && _endorsement$poliza.asegurado ? "".concat(endorsement === null || endorsement === void 0 ? void 0 : (_endorsement$poliza2 = endorsement.poliza) === null || _endorsement$poliza2 === void 0 ? void 0 : _endorsement$poliza2.asegurado.full_name, " ").concat(formatRut((endorsement === null || endorsement === void 0 ? void 0 : (_endorsement$poliza3 = endorsement.poliza) === null || _endorsement$poliza3 === void 0 ? void 0 : _endorsement$poliza3.asegurado.rut) || "")) : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("8%")
      }, renderStatusLabel(endorsement)), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("8%")
      }, endorsement.endorsement_type ? getEndorsementTypeLabel(endorsement.endorsement_type) : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("12%")
      }, (endorsement === null || endorsement === void 0 ? void 0 : (_endorsement$poliza4 = endorsement.poliza) === null || _endorsement$poliza4 === void 0 ? void 0 : (_endorsement$poliza4$ = _endorsement$poliza4.company) === null || _endorsement$poliza4$ === void 0 ? void 0 : _endorsement$poliza4$.name) || "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("8%")
      }, (endorsement === null || endorsement === void 0 ? void 0 : (_endorsement$poliza5 = endorsement.poliza) === null || _endorsement$poliza5 === void 0 ? void 0 : _endorsement$poliza5.ramo) || "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("8%")
      }, (endorsement === null || endorsement === void 0 ? void 0 : endorsement.cancel_reason_name) || "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("6%", {
          textAlign: "right"
        })
      }, formatCurrency(endorsement === null || endorsement === void 0 ? void 0 : endorsement.total_bonus, endorsement === null || endorsement === void 0 ? void 0 : endorsement.currency)), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("12%")
      }, endorsement.created_by_email ? endorsement.created_by_email : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("6%")
      }, endorsement.created_at ? moment(endorsement.created_at).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("6%")
      }, endorsement.start_date ? moment(endorsement.start_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
        style: getCellStyle("7%", {
          textAlign: "center"
        })
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: "4px",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(endorsement.poliza.id),
        className: "btn btn-info btn-xs",
        title: "Ver p\xF3liza",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        }
      }, /*#__PURE__*/React.createElement(FaEye, null)), /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(endorsement.poliza.id, "/poliza_endorsements"),
        className: "btn btn-primary btn-xs",
        title: "Ver endosos",
        style: {
          padding: "3px 6px",
          fontSize: "14px"
        }
      }, /*#__PURE__*/React.createElement(FaEdit, null)))));
    }))), scrollTooltip.show && /*#__PURE__*/React.createElement("div", {
      className: "scroll-tooltip",
      style: {
        left: scrollTooltip.x,
        top: scrollTooltip.y
      }
    }, scrollTooltip.text));
  }

  ;
  return /*#__PURE__*/React.createElement("h3", null, "No se han encontrado Endosos.");
};

export default ListEndorsement;